var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.764071 17.4169C0.342086 17.4169 0 17.0748 0 16.6528C0 16.2308 0.342086 15.8887 0.76407 15.8887H0.964134C1.49661 15.8887 1.92827 15.4571 1.92827 14.9246V8.28574C1.92827 6.91545 2.37102 5.70385 3.25653 4.65096C4.00761 3.75773 4.93961 3.13761 6.05253 2.79059C6.40581 2.68043 6.66667 2.36595 6.66667 1.99588C6.66667 1.64215 6.79618 1.34139 7.0552 1.09362C7.31422 0.846022 7.62871 0.722221 7.99867 0.722221C8.3688 0.722221 8.68373 0.846022 8.94347 1.09362C9.20338 1.34139 9.33333 1.64215 9.33333 1.99588C9.33333 2.36595 9.59419 2.68043 9.94747 2.79059C11.0604 3.13761 11.9924 3.75773 12.7435 4.65096C13.629 5.70385 14.0717 6.91545 14.0717 8.28574V14.9246C14.0717 15.4571 14.5034 15.8887 15.0359 15.8887H15.2359C15.6579 15.8887 16 16.2308 16 16.6528C16 17.0748 15.6579 17.4169 15.2359 17.4169H0.764071ZM7.99813 20.2778C7.46747 20.2778 7.01378 20.0974 6.63707 19.7367C6.5213 19.6259 6.42332 19.5083 6.34311 19.3837C6.0441 18.9194 6.51945 18.4358 7.07173 18.4358H8.92827C9.48055 18.4358 9.9563 18.9195 9.65717 19.3838C9.57654 19.5089 9.47793 19.627 9.36133 19.738C8.98338 20.0979 8.52898 20.2778 7.99813 20.2778Z",
    fill: "#44546F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotify);
export default __webpack_public_path__ + "static/media/notify.d280d8b1e650d1835af3cf57f1dfdfe3.svg";
export { ForwardRef as ReactComponent };